import '@ant-design/v5-patch-for-react-19';
import { ConfigProvider, ThemeConfig } from "antd"
import antdFR from "antd/lib/locale/fr_FR"

const customTheme: ThemeConfig = {
    token: {
        "colorPrimary": "#18BC9C",
        "colorInfo": "#0f758e",
        "wireframe": false
    },
    components: {},
    // hashed: false  // If there is only one version of antd in your application, you can set `false` to reduce the bundle size.
    cssVar: {
        // prefix: "ant", // Prefix for css variable.
        // key: "default" // Unique key for theme, should be set manually < react@18.
    }
}

export interface WithAntdProps {
    children: React.ReactNode
}

export const WithAntd = (props: WithAntdProps) => {
    const { children } = props

    return (
        <ConfigProvider
            locale={antdFR}
            theme={customTheme}>
            {children}
        </ConfigProvider>
    )
}
